export { default as ServiceAreasSection } from './service-areas-section';
